(function () {
  angular.module("irricrops").controller("programaFertTableCtrl", [
    "$mdDialog",
    "menu",
    "temporadaFac",
    "$stateParams",
    "global",
    "$http",
    "urls",
    function (
      $mdDialog,
      menu,
      temporadaFac,
      $stateParams,
      global,
      $http,
      urls
    ) {

      let vm = this;
      vm.loading = true;
      vm.temporadas = [];
      vm.temporadaSelected = null;
      vm.programas = [];
      vm.programaSelected = null;
      vm.productos = [];
      vm.productosSelected = [];
      vm.equipos = [];
      vm.elementos = [];
      vm.etapas = [];
      vm.totalHas = 0;
      vm.isDirty = false;
      vm.showTotalProductos = false;

      let vinedoId = $stateParams.id;

      let months = [
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
      ];

      let newProgramaTemplate = {
        id: 0,
        nombre: "programa nuevo",
        fechaInicio: "2021-01-01 00:00:00",
        fechaFin: "2021-03-01 00:00:00",

        isNew: true,
        vinedoId,
        etapas: [],
        sectoresSelected:[]
      };

      let newEtapaTemplate = {
        nombre: "etapa nueva",
        fechaInicio: "2021-01-01 00:00:00",
        fechaFin: "2021-03-01 00:00:00",

        dias: 0,
        progreso: 0,
        programa_fertilizacion_id: null,
        programa: [],
        real: [],

        isDirty: true,
        isNew: true,
        show: true,
        vinedoId,
        productos: [],
      };


      vm.getBaseData = () => {
        return menu
          .getSidebarProm()
          .then( () => temporadaFac.getTemporadas(false, { vinedo_id: vinedoId }))
          .then( res => {
              if (!vm.temporadas || vm.temporadas.length == 0) {
                vm.temporadas = res.data.data;
              }
              if (!vm.temporadaSelected) {
                vm.temporadaSelected = _.find(vm.temporadas, { activo: true });
              }
              vm.equipos = global.getSidebarData(vinedoId).equipos;
            }, err => console.error(err)
          );
      };



      vm.refreshTable = () => {
        return vm.getBaseData()
          .then(() => vm.getDataProgramaFert(), err => console.error(err))
      };


      vm.init = () => {
        vm.loading = true;
        return vm.refreshTable()
          .then(() => vm.loading = false);
      };
      vm.init();



      vm.getDataProgramaFert = () => {
        return $http({
          url: urls.BASE + "/fertilizacion/vinedo",
          params: {
            vinedo_id: vinedoId,
            periodo: vm.temporadaSelected.periodo,
          },
        }).then(res => {
          let { programas, productos } = vm.parseProgramasFertilizacion(
            res.data.data
          );
          vm.programas = programas;
          vm.productos = productos;
          vm.autoSelectPrograma();
        });
      };


      vm.autoSelectPrograma = () => {
          if (vm.programas.length > 0) {
            let programaSelected = vm.programaSelected ? vm.programas.find(p => p.id == vm.programaSelected.id) : _.first(vm.programas)
            programaSelected = programaSelected || _.first(vm.programas);
            vm.selectPrograma(programaSelected);
          }else{
            vm.cleanProgramSelected();
          }
      }


      vm.parseProgramasFertilizacion = data => {
        let programas = data.programas_fertilizacion;
        let productos = data.productos;

        programas.forEach(programa => {
          vm.parsePrograma(programa, productos);
        });

        programas = _.sortBy(programas, "id");

        return { programas, productos };
      };


      vm.parsePrograma = (programa, productos) => {
        let etapas = programa.sectores.flatMap(sector =>
          (sector.programas || []).map(etapa =>
            vm.parseEtapa(etapa, sector, productos)
          )
        );

        programa.etapas = vm.reduceEtapas(etapas);
        programa.productos = vm.getProductosPrograma(programa, productos);
        programa.elementos = vm.getElementosPrograma(programa, productos);
        programa.sectoresSelected = _.cloneDeep(programa.sectores);
      };

      vm.parseEtapa = (etapaOriginal, sector, productos) => {
        let etapa         = _.cloneDeep(etapaOriginal);
        etapa.show        = true;
        etapa.isDirty     = false;
        etapa.isNew       = false;
        etapa.fechaInicio = etapa.fecha_inicio;
        etapa.fechaFin    = etapa.fecha_fin;
        etapa.productos   = [];
        etapa.originalIds = [
          {
            sectorRiegoId: sector.id,
            etapaId: etapa.id,
          },
        ];

        productos.forEach((producto) => {
          let productoPrograma = etapa.programa.find(
            (p) => p.producto_id == producto.id
          );
          let productoReal = etapa.real.find(
            (p) => p.producto_id == producto.id
          );

          if (productoPrograma) {
            etapa.productos.push({
              ...producto,
              programa: productoPrograma.cantidad,
              real: productoReal,
            });
          }
        });

        delete etapa.id;
        delete etapa.programa;
        delete etapa.real;
        delete etapa.programa_fertilizacion_id;
        delete etapa.progreso;

        return etapa;
      };

      vm.reduceEtapas = etapas => {
        return etapas.reduce((accEtapas, etapa) => {
          let etapaFound = accEtapas.find(e => vm.isSameEtapa(e, etapa));
          if (etapaFound) {
            etapaFound.productos = etapaFound.productos.concat(etapa.productos)
                                  .reduce( (accProductos, producto) => {
                let productoFound = accProductos.find(
                  p => p.id == producto.id
                );
                if (productoFound) {
                  //productoFound.programa += producto.programa;
                  productoFound.programa = producto.programa;

                  productoFound.real.cantidad_mediciones +=
                    producto.real.cantidad_mediciones;

                  productoFound.real.total_mediciones +=
                    producto.real.total_mediciones;

                  productoFound.real.progreso = null;
                } else {
                  accProductos.push(producto);
                }
                return accProductos;
              },
              []
            );
            etapaFound.originalIds = etapaFound.originalIds.concat(
              etapa.originalIds
            );
          } else {
            accEtapas.push(etapa);
          }
          return accEtapas;
        }, []);
      };

      vm.getProductosPrograma = (programa, productos) => {
        return _.uniqBy(
          programa.etapas.flatMap((etapa) =>
            etapa.productos.map((producto) => {
              return productos.find((p) => p.id == producto.id);
            })
          ),
          "id"
        );
      };

      vm.getElementosPrograma = programa => {
        return _.uniqBy(
          programa.etapas.flatMap(etapa =>
            etapa.productos.flatMap(producto =>
              producto.elementos.map(e => {
                return {
                  id: e.id,
                  nombre: e.nombre,
                  orden: e.orden,
                  simbologia: e.simbologia,
                };
              })
            )
          ),
          "id"
        );
      };

      vm.getTotalEtapas = programa => {
        let totalEtapas = _.cloneDeep(newEtapaTemplate);

        totalEtapas.productos = (programa.productos || []).map(producto => {
          producto.totalProgramado = 0;
          producto.totalReal = 0;
          programa.etapas.forEach(etapa => {
            let productoFound = etapa.productos.find( p => p.id == producto.id);
            if (productoFound) {
              producto.totalProgramado = _.round(
                (producto.totalProgramado || 0) + parseFloat(productoFound.programa),
                2
              );
              let totalMediciones = productoFound.real !== undefined ? productoFound.real.total_mediciones : 0;
              let sumaTotalReal = (producto.totalReal || 0) + totalMediciones;
              producto.totalReal = _.round(sumaTotalReal, 2);
            }
          });
          return producto;
        });

        return totalEtapas;
      };

      vm.getElementoValue = function (producto, elemento) {
        let total_mediciones =
          producto && producto.real ? producto.real.total_mediciones : 0;
        let elementoProducto = producto.elementos.find(
          e => e.id == elemento.id
        );
        let elementoValue = 0;
        if (elementoProducto && elementoProducto.concentracion) {
          elementoValue = _.round(
            total_mediciones * elementoProducto.concentracion,
            2
          );
        }
        return _.round(elementoValue, 2);
      };

      vm.getElementoEtapaValue = (etapa, elementoEtapa) => {
        let value = 0;
        etapa.productos.forEach(producto => {
          value += vm.getElementoValue(producto, elementoEtapa);
        });
        return _.round(value, 2);
      };

      vm.getTotalElementoValue = function (producto, elemento) {
        let total_mediciones =
          producto && producto.totalReal ? producto.totalReal : 0;
        let elementoProducto = producto.elementos.find(
          e => e.id == elemento.id
        );
        let elementoValue = 0;
        if (elementoProducto && elementoProducto.concentracion) {
          elementoValue = _.round(
            total_mediciones * elementoProducto.concentracion,
            2
          );
        }
        return _.round(elementoValue, 2);
      };

      vm.getTotalElementoEtapaValue = (etapa, elementoEtapa) => {
        let value = 0;
        etapa.productos.forEach(producto => {
          value += vm.getTotalElementoValue(producto, elementoEtapa);
        });
        return _.round(value, 2);
      };

      vm.selectPrograma = programa => {
        if(vm.programaSelected && vm.programaSelected.totalEtapas){
          vm.programaSelected.totalEtapas = null;
        }
        vm.programaSelected = programa;
        if(programa && programa.sectoresSelected){
          vm.totalHas = _.sumBy(programa.sectoresSelected, "ha");
          programa.totalEtapas = vm.getTotalEtapas(programa);
        }else{
          vm.totalHas = 0;
          programa.totalEtapas = null;
        }
      };

      vm.cleanProgramSelected = () => {
        vm.programaSelected = null;
        vm.totalHas = 0;
      }

      vm.addNewPrograma = () => {
        //si ya existe un programa nuevo, no crea otro
        if (_.find(vm.programas, { isNew: true })) return;

        let programa = _.clone(newProgramaTemplate);
        programa.etapas = [];

        vm.addEtapasMeses(programa);
        vm.programas.push(programa);
        vm.selectPrograma(programa);
      };

      vm.deletePrograma = programa => {
        if (confirm("¿Seguro desea eliminar este programa?")) {
          vm.loading = true;
          if(programa.id){
            $http({
              method: "DELETE",
              url: urls.BASE + "/fertilizacion/programa-fertilizacion",
              params: {
                id: programa.id,
              },
            }).then(res => {
              vm.loading = false;
              vm.afterDeleteProgram(programa);
            });
          }else{
            vm.loading = false;
            vm.afterDeleteProgram(programa);
          }
        }
      };

      vm.afterDeleteProgram = programa => {
        const index = vm.programas.indexOf(programa);
        if (index > -1) {
          vm.programas.splice(index, 1);
        }
        if (programa == vm.programaSelected) {
          vm.selectPrograma(_.first(vm.programas));
        }
      }

      vm.deleteEtapa = etapa => {
        if (confirm("¿Seguro desea eliminar esta etapa?")) {
          vm.loading = true;
          let promises = [];

          //si no tiene originalIds, es una etapa nueva
          if(etapa.originalIds){
            etapa.originalIds.forEach(ids => {
              let prom = $http({
                method: "DELETE",
                url: urls.BASE + "/fertilizacion/programa",
                params: {
                  id: ids.etapaId
                }
              })
              promises.push(prom);
            });
          }

          if(promises.length > 0){
            Promise
              .all(promises)
              .then(() => {
                vm.programaSelected.etapas = vm.programaSelected.etapas.filter(e => e !== etapa);
                vm.loading = false;
              });
          }else{
                vm.programaSelected.etapas = vm.programaSelected.etapas.filter(e => e !== etapa);
                vm.programaSelected.totalEtapas = vm.getTotalEtapas(vm.programaSelected);
                vm.loading = false;
          }


        }
      }

      vm.selectSectoresCallback = dataDialog  => {
        let selected = dataDialog.seleccionados.map(sector => {
          return {
            id: sector.id,
            ha: sector.ha,
            nombre: sector.nombre,
          };
        });
        vm.isDirty = true;
        vm.programaSelected.etapas.forEach(et => et.isDirty = true);
        vm.programaSelected.sectoresSelected = _.uniqBy(selected, "id");
        vm.totalHas = _.sumBy(vm.programaSelected.sectoresSelected, "ha");
        vm.programaSelected.totalEtapas = vm.getTotalEtapas(vm.programaSelected);
      };


      vm.savePrograma = programa => {
        vm.loading = true;

        let data = {
          nombre            : programa.nombre,
          fecha_inicio      : vm.temporadaSelected.inicio,
          fecha_fin         : vm.temporadaSelected.fin,
          vinedo_id         : vinedoId,
          sectores_riego_id : programa.sectoresSelected
            ? programa.sectoresSelected.map(sector => sector.id)
            : [],
        };

        if (programa.id) {
          data.id = programa.id;
        }

        $http({
          method: "POST",
          url: urls.BASE + "/fertilizacion/programa-fertilizacion",
          data: data,
        }).then(res => {
          programa.isNew = false;
          vm.isDirty = false;

          if (!programa.id) {
            programa.id = parseInt(res.data.id);
          }

          programa.etapas.forEach(etapa => {
            if(etapa.isDirty){
              vm.saveEtapaProgramFert(programa, etapa);
            }
          });

          return this.refreshTable().then(() => vm.loading = false);
        });
      };



      vm.saveEtapaProgramFert = (programa, etapa) => {
        let sectoresIds = etapa.originalIds || [];

        programa.sectoresSelected.forEach(sectorSelected => {
          if (!sectoresIds.find(s => s.sectorRiegoId == sectorSelected.id)) {
            sectoresIds.push({
              sectorRiegoId: sectorSelected.id,
              etapaId: null,
            });
          }
        });

        let params = {
          programa_fertilizacion_id : programa.id,
          nombre                    : etapa.nombre,
          fecha_inicio              : etapa.fechaInicio,
          fecha_fin                 : etapa.fechaFin,
          productos                 : etapa.productos.map((producto) => ({
            id: producto.id,
            unidades: parseFloat(producto.programa) || 0,
          })),
        };

        let promises = [];
        sectoresIds.forEach(ids => {
          let data = {
            ...params,
            sector_riego_id: [ids.sectorRiegoId],
          };

          if (ids.etapaId) {
            data.id = ids.etapaId;
          }

          let prom = $http({
            method: "POST",
            url: urls.BASE + "/fertilizacion/programa",
            data: data,
          });
          prom.then(res => {
            etapa.isNew = false;
            etapa.isDirty = false;
            /*if (!etapa.id) {
              etapa.id = parseInt(res.data.id);
            }*/
          });
          promises.push(prom);
        });
        return Promise.all(promises);
      };

      vm.changeInput = (etapa, producto) => {
        vm.isDirty = true;
        etapa.isDirty = true;
        vm.programaSelected.totalEtapas = vm.getTotalEtapas(vm.programaSelected);
      };


      vm.addEtapa = ev => {
        vm.showDialogEditEtapa(ev, _.clone(newEtapaTemplate)).then(
          etapa => {
            etapa.productos = _.cloneDeep(vm.programaSelected.productos);
            vm.programaSelected.etapas.unshift(etapa);
          },
          err => console.error(err)
        );
      };

      vm.addEtapasMeses = programa => {
        let fechaInicio = vm.temporadaSelected.inicio;

        let fechaFin = moment(fechaInicio).endOf("month").format("YYYY-MM-DD");

        for (let i = 0; i < 12; i++) {
          let etapa         = _.clone(newEtapaTemplate);
          etapa.nombre      = months[i];
          etapa.fechaInicio = fechaInicio;
          etapa.fechaFin    = fechaFin;
          etapa.productos   = _.cloneDeep(programa.productos) || [];
          programa.etapas.push(etapa);

          fechaInicio = moment(fechaInicio)
            .add(1, "month")
            .format("YYYY-MM-DD");

          fechaFin = moment(fechaInicio).endOf("month").format("YYYY-MM-DD");
        }
      };

      
      vm.changeProductos = ev => {
        vm.isDirty = true;
        vm.showDialogProductos(ev)
          .then(productosSelected => {
          vm.programaSelected.productos = productosSelected;
          vm.programaSelected.etapas.forEach(etapa => {
            etapa.isDirty = true;
            etapa.productos = productosSelected.map(prodSelected => {
              return etapa.productos.find(p => prodSelected.id == p.id) || _.cloneDeep(prodSelected);
            })
          });
          vm.programaSelected.totalEtapas = vm.getTotalEtapas(vm.programaSelected);
        });
      };



      vm.showDialogProductos = ev => {
        let parent = document.getElementsByClassName("md-dialog-container")[0];

        if (parent == null) {
          parent = angular.element(document.body);
        }

        return $mdDialog.show({
          controller: [
            "$mdDialog",
            "productos",
            "productosSelected",
            function ($mdDialog, productos, productosSelected) {
              let vm = this;

              vm.productosSelectable = productos.map(p => {
                let isSelected = Boolean(
                  productosSelected &&
                    productosSelected.find(ps => ps.id == p.id)
                );
                return { ...p, isSelected };
              });

              vm.save = () => {
                let productosSelected = vm.productosSelectable
                  .filter( p => p.isSelected)
                  .map( p => productos.find(pr => p.id == pr.id));
                $mdDialog.hide(productosSelected);
              };

              vm.cancel = () => {
                $mdDialog.cancel();
              };


            },
          ],
          controllerAs: "sp",
          templateUrl:
            "components/vinedo/newtimeline/programaFertTable/selectProductos.tmpl.html",
          parent: parent,
          targetEvent: ev,
          clickOutsideToClose: true,
          multiple: true,
          locals: {
            productos: vm.productos,
            productosSelected: vm.programaSelected.productos,
          },
        });
      };

      vm.editEtapa = (ev, etapa) => {
        return vm.showDialogEditEtapa(ev, etapa).then(etapaEdited => {
          etapa.nombre = etapaEdited.nombre;
          etapa.fechaInicio = etapaEdited.fechaInicio;
          etapa.fechaFin = etapaEdited.fechaFin;
          etapa.isDirty = true;
          return etapa;
        });
      };

      vm.showDialogEditEtapa = (ev, etapa) => {
        let parent = document.getElementsByClassName("md-dialog-container")[0];

        if (parent == null) {
          parent = angular.element(document.body);
        }

        return $mdDialog.show({
          controller: [
            "$mdDialog",
            "etapa",
            "productos",
            function ($mdDialog, etapa, productos) {
              let vm = this;
              vm.etapaEditable = _.clone(etapa);
              vm.productos = productos;
              vm.cancel = () => $mdDialog.cancel();
              vm.save = () => {
                return $mdDialog.hide({
                  ...etapa,
                  nombre: vm.etapaEditable.nombre,
                  fechaInicio:
                    moment(vm.etapaEditable.fechaInicio).format("YYYY-MM-DD") +
                    " 00:00:00",
                  fechaFin:
                    moment(vm.etapaEditable.fechaFin).format("YYYY-MM-DD") +
                    " 00:00:00",
                });
              };
            },
          ],
          controllerAs: "ep",
          templateUrl:
            "components/vinedo/newtimeline/programaFertTable/editEtapaProgramaFert.tmpl.html",
          parent: parent,
          targetEvent: ev,
          clickOutsideToClose: true,
          multiple: true,
          locals: {
            etapa: etapa,
            productos: vm.productos,
          },
        });
      };

      vm.isSameEtapa = (etapaA, etapaB) => {
        return (
          etapaA.nombre      == etapaB.nombre &&
          etapaA.fechaInicio == etapaB.fechaInicio &&
          etapaA.fechaFin    == etapaB.fechaFin
        );
      };

      vm.close = () => {
        $mdDialog.cancel();
      };


    },
  ]);
})();
